import React from 'react';
import Navbar from '../components/Navbar';
import './InfinityPlusDocs.css';

function InfinityPlusDocs() {
  return (
    <div>
      <Navbar />
      <div className="docs-section">
        <h1>InfinityPlus Datasource Documentation</h1>
        <p>
          Welcome to the InfinityPlus Datasource documentation. This page covers new features added to the InfinityPlus Datasource, such as Azure Managed Identity (MSI) authentication. For detailed information on the base features, please refer to the original documentation.
        </p>
        <h2>New Features</h2>
        <div className="feature">
          <h3>Azure Managed Identity (MSI) Authentication</h3>
          <p>
            The Azure Managed Identity (MSI) authentication feature allows the InfinityPlus datasource to securely authenticate against Azure services using managed identities. This integration streamlines access management and enhances security by eliminating the need for manual credential management.
          </p>
          <h4>Example Configuration</h4>
          <pre className="code-block">
            {`{
  "name": "Azure MSI Example",
  "type": "InfinityPlus",
  "access": "proxy",
  "url": "https://management.azure.com/",
  "jsonData": {
    "authType": "msi"
  }
}`}
          </pre>
          <p>
            This configuration allows the datasource to connect to Azure using the system-assigned managed identity of the virtual machine or app service where Grafana is running. No additional credentials are required.
          </p>
        </div>
        <h2>Further Reading</h2>
        <p>
          For a comprehensive guide on all other features, please visit the original Grafana Infinity Datasource documentation:
        </p>
        <a href="https://grafana.com/grafana/plugins/yesoreyeram-infinity-datasource" target="_blank" rel="noopener noreferrer" className="link-button">
          Original Infinity Datasource Documentation
        </a>
      </div>
    </div>
  );
}

export default InfinityPlusDocs;
